import { useState, useEffect } from "react";
import axios from "axios";
import { generateEndpoint } from "utils/helpers/generateEndpoint";

const useFetchStripeTransaction = (intentId) => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [data, setData] = useState(null);

  useEffect(() => {
    const fetchIntentDetails = async () => {
      try {
        // Check if this is a setup intent (trial) - just return placeholder data
        if (intentId && intentId.startsWith('seti_')) {
          console.log("Setup intent detected, returning placeholder data for trial");
          
          // Return placeholder data for trials
          // TODO : Properly fetch setupIntent from STripe via Lambda
          setData({
            paymentIntentId: intentId,
            isTrial: true
          });
          setLoading(false);
          return;
        }

        // Regular payment intent handling
        const endpoint = generateEndpoint(
          process.env.REACT_APP_AWS_DEV_POST_STRIPE_FETCH_TRANSACTION_ENDPOINT,
          process.env.REACT_APP_AWS_PROD_POST_STRIPE_FETCH_TRANSACTION_ENDPOINT
        );
        const response = await axios.post(endpoint, {
          paymentIntentId: intentId,
        });

        setData(response.data.paymentIntent);
      } catch (error) {
        console.error("Error fetching stripe transaction:", error);
        setError(error.response?.data?.error || error.message);
      } finally {
        setLoading(false);
      }
    };

    if (intentId) {
      fetchIntentDetails();
    } else {
      setLoading(false);
    }
  }, [intentId]);

  return { loading, error, data };
};

export default useFetchStripeTransaction;